export default __webpack_public_path__ + "static/media/inner_logo.6731cde2.png";